module.exports = __webpack_public_path__ + "img/huiyu-back-cp@3x.c70974aa.png";